/**
 * Display-only pricing constants for the Pro plan (CC-SPEC item 4).
 *
 * The amount actually charged is the Stripe price referenced by
 * STRIPE_PROFESSIONAL_PRICE_ID on the edge function — these strings are
 * marketing copy and must be kept in sync with the live price by hand.
 * Centralized here so the figure isn't duplicated across the signup form
 * and the landing page.
 *
 * PRO_TRIAL_DAYS mirrors the checkout default (STRIPE_TRIAL_PERIOD_DAYS,
 * default 14) in supabase/functions/stripe-checkout. If you change the
 * trial length there, update this so the copy matches.
 */
export const PRO_PRICE_LABEL = '$99/mo';
export const PRO_TRIAL_DAYS = 14;
export const PRO_TRIAL_SUMMARY = `${PRO_TRIAL_DAYS}-day free trial`;
